import { Dialog } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  SCloseButton,
  SDialogContent,
  SGridColumn1,
  SGridContainer,
} from "./styles";

interface PropsTypes {
  open: boolean;
  onClose: () => void;
}

export const MobileWarningDialog: React.FC<PropsTypes> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 8 },
      }}
      hideBackdrop
      maxWidth="xs"
    >
      <SGridContainer>
        <SDialogContent>
          <SGridColumn1>{t("mobileWarning.message")}</SGridColumn1>
        </SDialogContent>
        <SCloseButton onClick={onClose}>OK</SCloseButton>
      </SGridContainer>
    </Dialog>
  );
};
